import SettingsService from '@/common/api/settings'
import { SET_BANK_ACCOUNT } from './mutations'

const state = {
  setting: {},
  bankAccount: {}
}

const getters = {
  setting: (state) => state.setting
}

const actions = {
  getSetting (context, id) {
    return new Promise((resolve, reject) => {
      SettingsService.get(id)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  getDefaultSetting () {
    return new Promise((resolve, reject) => {
      SettingsService.query()
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  getAllOperatorAuthentic () {
    return new Promise((resolve, reject) => {
      SettingsService.getAllOperatorAuthentic()
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  importTag (context, params) {
    return new Promise((resolve, reject) => {
      SettingsService.importTag(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  exportTag (context, params) {
    return new Promise((resolve, reject) => {
      SettingsService.exportTag(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  updateBankAccount (context, params) {
    return new Promise((resolve, reject) => {
      SettingsService.updateBankAccount(params.data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  getBirthDayTag (context, params) {
    return new Promise((resolve, reject) => {
      SettingsService.getBirthDayTag(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  }
}

const mutations = {
  [SET_BANK_ACCOUNT] (state, data) {
    state.bankAccount = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
